export function getMessagesPageShellClassName({
  activeView = 'direct',
  threadId = '',
  boardTopicId = '',
  isMobile = false,
  isCompactPwaViewport = false,
} = {}) {
  const isDirect = activeView === 'direct';
  const hasDirectThread = isDirect && Boolean(threadId);
  const hasBoardThread = activeView === 'boards' && Boolean(boardTopicId);
  const isCompactShell = Boolean(isMobile || isCompactPwaViewport);
  const classes = [
    'search-page',
    'search-page--messages',
    `search-page--${isDirect ? 'direct' : 'boards'}`,
  ];

  if (hasDirectThread) classes.push('search-page--direct-active-thread');
  if (hasBoardThread) classes.push('search-page--boards-active-thread');
  if (isCompactShell && (hasDirectThread || hasBoardThread)) classes.push('search-page--pwa-chat-first');
  if (isCompactShell && !hasDirectThread && !hasBoardThread) classes.push('search-page--message-list');

  return classes.join(' ');
}
